'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function remove(arr, shouldRemoveElement) {
    var originalArr = arr.slice();
    var removed = [];
    var resultIndex = 0;
    for(var i = 0; i < arr.length; i++){
        if (shouldRemoveElement(arr[i], i, originalArr)) {
            removed.push(arr[i]);
            continue;
        }
        if (!Object.hasOwn(arr, i)) {
            delete arr[resultIndex++];
            continue;
        }
        arr[resultIndex++] = arr[i];
    }
    arr.length = resultIndex;
    return removed;
}
exports.remove = remove;
